export { default } from './FeeToleranceLegend';
